import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { Routes, Route, BrowserRouter } from 'react-router';
import './App.less';
import { CINEMA_UI_URL } from './common/config';
import { getAccessToken } from './common/util/helper';
import DefaultLayout from './layouts/defaultLayout';
import store from './store';
import 'antd/lib/style/default.less';
import './style/antd-override.less';
import './style/qw-css.less';
import './style/qw-theme.less';

import { Enviroinment } from './common/enums';
import I18n from './locale';

const App = () => {
  useEffect(() => {
    if (!getAccessToken() && process.env.REACT_APP_ENV !== Enviroinment.test) {
      window.location = CINEMA_UI_URL;
    }
  }, []);

  return (
    <Provider store={store}>
      <I18nextProvider i18n={I18n}>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<DefaultLayout />} />
          </Routes>
        </BrowserRouter>
      </I18nextProvider>
    </Provider>
  );
};

export default App;
